import { render, staticRenderFns } from "./seguro-empate-badge.vue?vue&type=template&id=987d9308&scoped=true&"
import script from "./seguro-empate-badge.vue?vue&type=script&lang=js&"
export * from "./seguro-empate-badge.vue?vue&type=script&lang=js&"
import style0 from "./seguro-empate-badge.vue?vue&type=style&index=0&id=987d9308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987d9308",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsSeguroEmpateTooltip: require('/var/web/bet777.es/components/elements/seguro-empate-tooltip.vue').default})
